<template>

  <div>
    <div class="skinny row">
      <div class="col-sm-12 col-md-4 mb--10">
        <select class="form-control" v-model.number="year" @change="resetDays" :disabled="date_disabled">
          <option value="" disabled selected>AAAA</option>
          <option :value="y" v-for="y in years">{{y}}</option>
        </select>
      </div>
      <div class="col-sm-12 col-md-4 mb--10">
        <select class="form-control" v-model.number="month" @change="resetDays" :disabled="date_disabled">
          <option value="" disabled selected>MM</option>
          <option value="1">01</option>
          <option value="2">02</option>
          <option value="3">03</option>
          <option value="4">04</option>
          <option value="5">05</option>
          <option value="6">06</option>
          <option value="7">07</option>
          <option value="8">08</option>
          <option value="9">09</option>
          <option value="10">10</option>
          <option value="11">11</option>
          <option value="12">12</option>
        </select>
      </div>
      <div class="col-sm-12 col-md-4 mb--10">
        <select class="form-control" v-model.number="day" :disabled="date_disabled">
          <option value="" disabled selected>DD</option>
          <option :value="d" v-for="d in days">{{ d < 10 ? '0'+ d : d}}</option>
        </select>
      </div>
    </div>
  </div>

</template>

<script>
export default  {
  name: 'SetDate',
  props: ['base_date', 'base_year', 'date_disabled'],
  mounted() {
    var year =new Date().getFullYear()
    this.years.push(year)
    var base_year = year - 99
    if(this.base_year !== undefined){
      base_year = parseInt(this.base_year)
    }

    for(var i = 1; year - i > base_year; i++ ){
      this.years.push(year - i)
    }

    for(var j = 1; j <= 30; j ++){
      this.days.push(j)
    }

    this.resetBaseDate()

  },
  watch:{
    year: function(){
      this.giveDate()
      this.$emit('year', this.year)
    },
    month: function(){
      this.giveDate()
      this.$emit('month', this.month)
    },
    day: function(){
      this.giveDate()
      this.$emit('day', this.day)
    },
    base_date: function(){
      this.resetBaseDate()
    }
  },
  data() {
    return {
      days: [],
      years: [],
      year: '',
      month: '',
      day: '',
    }
  },
  methods: {
    resetDays(){
      if(this.month  != ''){
        this.days = []
        if(this.month == 1 || this.month == 3 || this.month == 5 || this.month == 7 || this.month == 8 || this.month == 10 || this.month == 12){
          this.days = []
          for(var i = 1; i <= 31; i ++){
            this.days.push(i)
          }
        }else if(this.month == 4 || this.month == 6 || this.month == 9 || this.month == 11){
          for(var i = 1; i <= 30; i ++){
            this.days.push(i)
          }
          if(this.day != '' && this.day > 30){
            this.day = 30
          }
        }else if(this.month == 2){
          if((this.year%4 == 0 && this.year%100 != 0) || this.year%400 == 0){
            for(var i = 1; i <= 29; i ++){
              this.days.push(i)
            }
            if(this.day != '' && this.day > 29){
              this.day = 29
            }
          }else{
            for(var i = 1; i <= 28; i ++){
              this.days.push(i)
            }
            if(this.day != '' && this.day > 28){
              this.day = 28
            }
          }
        }
      }

    },
    resetBaseDate(){
      if(this.base_date !== undefined && this.base_date !== null && this.base_date !== ''){
        var elements = this.base_date.split('-')
        try{
          this.year = parseInt(elements[0])
          this.month = parseInt(elements[1])
          this.day = parseInt(elements[2])
        }catch(error){
          this.year = ''
          this.month = ''
          this.day = ''
        }
      }
    },
    giveDate(){
      if(this.year != '' && this.day != '' && this.month != ''){
        var date = this.year.toString() + '-' + this.month.toString() + '-' + this.day.toString()
        this.$emit('set', date)
      }
    },
  },
  computed: {

  }
}
</script>

<style scoped lang="scss">
.set-date {

}
</style>
